<template>
    <div  class="page">
        <header class="tab-header">
            <div>
                <div>我的活动</div>
                <div></div>
            </div>
            <div>
                <div>全部活动</div>
                <div></div>
            </div>
        </header>

        <main>
            <!-- <ListItem> </ListItem> -->
            <!-- <ListItem> </ListItem> -->
            <!--<ListItem> </ListItem>-->
            <!--<ListItem> </ListItem>-->
            <!--<ListItem> </ListItem>-->
            <!--<ListItem> </ListItem>-->
            <!--<ListItem> </ListItem>-->
        </main>

        <div class="list-none" v-if="true">
            <img src="../../../assets/list-none.png" alt="">
            <div>空荡荡的~暂无数据！</div>
        </div>

    </div>
</template>

<script>
    // import ListItem from "./ListItem";
    export default {
        name: "List",

        components: {
            // ListItem
        },

        created() {
            document.title = "活动";
        }
    }
</script>

<style scoped lang="scss">
    @import "../pay/page";

    main {
        margin-bottom: 40px;
    }
</style>
